import { defineAsyncComponent, hydrateOnVisible, hydrateOnIdle } from 'vue';
import { mapGetters, mapActions } from 'vuex';
import enJSON from '@/common/utilities/lang/en/home-new.js';
import esJSON from '@/common/utilities/lang/es/home-new.js';
import mvtHeader from '@/common/components/mvtheader/mvt-header.vue';
import lazyCarouselCheckMixin from '../../../common/mixins/lazycarouselcheck';
import homeWelcome from '../homewelcome/home-welcome.vue';
import homeTopActions from '@/home/components/hometopactions/home-topactions.vue';
import { parseQueryString } from '@/common/utilities/nojq/_utilities.js';
import { setStorage, getStorage, removeStorage } from '../../../common/utilities/nojq/_localstorage.js';

const mvtFooter = defineAsyncComponent({
    loader: () => import(/* webpackChunkName: "vhome" */ '@/common/components/mvtfooter/mvt-footer.vue'),
    hydrate: hydrateOnVisible({ rootMargin: '200px' }),
});

const homeNearbyViewed = defineAsyncComponent(
    () => import(/* webpackChunkName: "vhome" */ '../homenearbyviewed/home-nearbyviewed.vue'),
);

const homeLinks = defineAsyncComponent({
    loader: () => import(/* webpackChunkName: "vhome" */ '../homelinks/home-links.vue'),
    hydrate: hydrateOnVisible({ rootMargin: '100px' }),
});

const homeNavigation = defineAsyncComponent({
    loader: () => import(/* webpackChunkName: "vhome" */ '../homenavigation/home-navigation.vue'),
    hydrate: hydrateOnVisible({ rootMargin: '100px' }),
});

const homePopularCities = defineAsyncComponent({
    loader: () => import(/* webpackChunkName: "vhome" */ '@/home/components/homepopularcities/home-popularcities.vue'),
    hydrate: hydrateOnVisible({ rootMargin: '200px' }),
});

const homePhotos = defineAsyncComponent({
    loader: () => import(/* webpackChunkName: "vhome" */ '../homephotos/home-photos.vue'),
    hydrate: hydrateOnVisible({ rootMargin: '100px' }),
});

const homeHotlead = defineAsyncComponent({
    loader: () => import(/* webpackChunkName: "vhome" */ '../homehotlead/home-hotlead.vue'),
    hydrate: hydrateOnVisible({ rootMargin: '200px' }),
});

const mvtDialogCenter = defineAsyncComponent({
    loader: () => import(/* webpackChunkName: "vhome" */ '@/common/components/mvtdialogcenter/mvt-dialogcenter.vue'),
    hydrate: hydrateOnIdle(),
});

const mvtPopSignin = defineAsyncComponent({
    loader: () => import(/* webpackChunkName: "vhome" */ '@/common/components/mvtpopsignin/mvt-popsignin.vue'),
    hydrate: hydrateOnIdle(),
});

export default {
    name: 'pageHome',
    inject: ['$eventBus'],
    components: {
        mvtPopSignin,
        homeWelcome,
        homePhotos,
        homeLinks,
        mvtDialogCenter,
        mvtHeader,
        mvtFooter,
        homeTopActions,
        homeNavigation,
        homeHotlead,
        homePopularCities,
        homeNearbyViewed,
    },
    mixins: [lazyCarouselCheckMixin],
    data() {
        return {
            showRecentlyViewed: false,
        };
    },
    mounted() {
        this.showRecentlyViewed = !!(this.glb.viewedListings && this.glb.viewedListings.length);
        this.$eventBus.$emit('eventbus-pageLoaded');
        const queryObj = parseQueryString();
        const isGoogleRedirect = location.href.match(/idToken=/);
        if (isGoogleRedirect) {
            if (queryObj.idToken) {
                import(/* webpackChunkName: "gtm-deps" */ '../../../../widget/spec/ga4helper').then(({ getGa4Trigger }) => {
                    var data = {
                        credential: queryObj.idToken,
                        clientId: this.glb.googleLoginClientId,
                        userType: this.glb.pageInfo.userType,
                        trigger: getGa4Trigger(getStorage('googleLoginTrigger'), getStorage('googleLoginRequestName', this.requestName)),
                    };
                    this.loginForGoogleAccount(data).then((res) => {
                        setStorage('isGoogleLogin', true);
                        this.$eventBus.$emit('eventbus-context-update');
                        this.afterGoogleLogin();
                    });
                });
            } else {
                this.afterGoogleLogin();
            }
        }
        this.checkForConciergeRequest();
        if (this.$route.query.confirm_cer) {
            this.$eventBus.$emit('dialog-center', {
                name: 'mvtConfirmCER',
                trigger: 'mvtConfirmCER',
                opt: {},
            });
        }
    },
    methods: {
        ...mapActions('glb', ['loginForGoogleAccount']),
        afterGoogleLogin() {
            let urlToRedirect = getStorage('googleRedirectUrl') || '';
            removeStorage('googleRedirectUrl');
            setTimeout(() => {
                window.open(urlToRedirect, '_self');
            }, 500);
        },
        openContactUs() {
            this.$eventBus.$emit('dialog-open-contactus');
        },
        checkForConciergeRequest() {
            var search = window.location.search;
            if (search && search.indexOf('popconciergerequest=1') > -1) {
                this.$eventBus.$emit('dialog-center', {
                    name: 'myConcierge',
                    opt: { popconciergerequest: true },
                    trigger: this.$options.name,
                });
            }
        },
    },
    computed: {
        ...mapGetters('glb', ['viewport', 'glb', 'getSplit']),
        ...mapGetters('home', ['home']),
    },
    beforeCreate() {
        this.injectMolangDataStore({ type: 'home', en: enJSON, es: esJSON });
    },
};
